import { makeStyles } from 'tss-react/mui';

const name = 'ChainLabel';

export const useChainLabelStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadiusSm,
    lineHeight: 1,
  },
}));
